import React from 'react'
import Radium from 'radium'
import { semanticColors } from '../../../../../Globals/styles'

const Cell = ({ content, style, inputStyle, readOnly, onChange, onFocus, onFocusOut, onClick, inputClassName, children, ref }) => {
    return (
        <div style={[styles.cell, style]}
            onClick={() => { onClick ? onClick() : {} }}>
            <textarea
                className={inputClassName}
                ref={ref ? ref : undefined}
                type="text"
                value={content}
                readOnly={readOnly ? readOnly : false}
                style={[styles.input, inputStyle]}
                onChange={(e) => {
                    if (onChange) {
                        onChange(e.target.value)
                    }
                }}
                onFocus={() => onFocus ? onFocus() : {}}
                onBlur={() => onFocusOut ? onFocusOut() : {}}
            />
            {children}
        </div>
    );
}

const styles = {
    cell: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    },
    input: {
        width: '100%',
        resize: 'none',
        outline: 'none',
        overflow: 'hidden',
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
        // height: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        margin: 'auto',
        display: 'block',
        borderBottom: '1px solid ' + 'transparent',      
        borderTopStyle: 'none',
        borderLeftStyle: 'none',
        borderRightStyle: 'none',  
        ':focus': {
            outline: 'none',
            borderBottom: '1px solid ' + 'white',
        }
    }
}

export default Radium(Cell);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/spreadsheets/table/cellTextarea.js